import React from 'react';
import styled from 'styled-components';
import SectionHeading from '../../components/common/SectionHeading';

const Wrapper = styled.section`
  background: ${({ theme }) => theme.colors.surface};
  border-radius: 1.5rem;
  padding: 2.5rem;
  box-shadow: ${({ theme }) => theme.shadows.md};
`;

const CardGrid = styled.div`
  margin-top: 2rem;
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
`;

const Card = styled.article`
  border: 1px solid ${({ theme }) => theme.colors.surfaceMuted};
  border-radius: 1rem;
  padding: 1.2rem;
  background: ${({ theme }) => theme.colors.surface};
`;

const CardTitle = styled.h3`
  margin: 0 0 0.5rem;
  font-size: 1.05rem;
`;

const CardDescription = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.textMuted};
  line-height: 1.6;
`;

const EmptyState = styled.p`
  margin: 1.2rem 0 0;
  color: ${({ theme }) => theme.colors.textMuted};
`;

const PortalPageTemplate = ({ eyebrow, title, description, cards = [], emptyMessage = '' }) => (
  <Wrapper>
    <SectionHeading eyebrow={eyebrow} title={title} description={description} />
    {cards.length > 0 && (
      <CardGrid>
        {cards.map((card) => (
          <Card key={card.title}>
            <CardTitle>{card.title}</CardTitle>
            <CardDescription>{card.description}</CardDescription>
          </Card>
        ))}
      </CardGrid>
    )}
    {cards.length === 0 && emptyMessage && <EmptyState>{emptyMessage}</EmptyState>}
  </Wrapper>
);

export default PortalPageTemplate;
